import { head } from 'lodash-es';

export const SUPPORTED_LOCALES = ['en-GB', 'en', 'fr', 'de', 'es', 'nl'];
export const DEFAULT_LOCALE = 'en-GB';

export function detectLocale(userLanguage) {
    const baseLocale = head(userLanguage.split('-'));

    return SUPPORTED_LOCALES.find((loc) => loc === userLanguage || loc === baseLocale) || DEFAULT_LOCALE;
}
